import React, { useMemo } from 'react';

import Box from '@mui/material/Box';

import TSTable, { DeleteButtonTableCell, DateTableCell } from '@ts-core/components/Table';
import { TSTableColumn } from '@ts-core/components/Table/TSTable/TSTable';

import { ProfessorActivityAnswer } from '../../types';

interface ActivityAnswersTableProps {
  answers?: ProfessorActivityAnswer[];
  loading?: boolean;

  onDeleteAnswer?: (answer: ProfessorActivityAnswer) => void;
  onAnswerClick?: (answer: ProfessorActivityAnswer) => void;

  onSearch?: (query: string) => void;
}

const ActivityAnswersTable = (props: ActivityAnswersTableProps) => {
  const { answers, loading, onDeleteAnswer, onSearch, onAnswerClick } = props;

  const columns = useMemo((): TSTableColumn<ProfessorActivityAnswer>[] => {
    const result: TSTableColumn<ProfessorActivityAnswer>[] = [
      {
        Header: 'Nombre',
        accessor: 'student.name',
        sortable: true,
      },
      {
        Header: 'Email',
        accessor: 'student.email',
        sortable: true,
      },
      {
        Header: 'Grupo',
        value: 'Grupo',
        accessor: 'student.group.name',
        id: 'student.group.name',
        sortable: true,
        filterable: true,
      },
      {
        Header: 'Fecha',
        accessor: 'createdAt',
        valueTransformer: (value: string) => <DateTableCell date={value} />,
        sortable: true,
      },
      {
        Header: '¿Corregido?',
        accessor: 'graded',
        value: '¿Corregido?',
        id: 'graded',
        valueTransformer: (value: boolean) => (value ? 'Si' : 'No'),
        filterable: true,
      },
      {
        Header: 'Resultado',
        accessor: 'score',
        valueTransformer: (value?: string) => value || '-',
        sortable: true,
      },
    ];

    if (onDeleteAnswer) {
      result.push({
        Header: '',
        accessor: 'id',
        valueTransformer: (value: string, column: any, activity: ProfessorActivityAnswer) => (
          <Box>
            <DeleteButtonTableCell message="¿Seguro de que deseas eliminar esta respuesta?" item={activity} onConfirm={onDeleteAnswer} />
          </Box>
        ),
      });
    }

    return result;
  }, [onDeleteAnswer]);

  return <TSTable loading={loading} columns={columns} data={answers} onSearch={onSearch} onSelectRow={onAnswerClick} />;
};

export default ActivityAnswersTable;
